var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { staticClass: "elevation-1" },
        [
          _c(
            "v-flex",
            {
              staticClass: "extra-content",
              class: {
                "pt-12": _vm.mdAndUp,
                "pt-5 px-10": _vm.smAndDown,
                "px-5": _vm.xl || _vm.smAndDown,
                "pl-6": _vm.lg,
                "pl-1 pr-9": _vm.md,
              },
              attrs: { xs12: "", sm12: "", md12: "", lg12: "", xl12: "" },
            },
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      class: { "ta-c": _vm.smAndDown },
                      attrs: {
                        cols: "12",
                        xl: "7",
                        lg: "8",
                        md: "8",
                        sm: "12",
                      },
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "page-heading",
                          class: {
                            "ml-n3":
                              _vm.smAndDown || _vm.xl || _vm.lg || _vm.md,
                          },
                        },
                        [_vm._v("My Quotes")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { class: { "px-5": _vm.smAndDown }, attrs: { justify: "center" } },
        [
          _vm.showFilters
            ? _c(
                "v-col",
                {
                  class: {
                    "ml-n6 pr-10": _vm.md || _vm.lg,
                    "px-5": _vm.smAndDown,
                  },
                  attrs: { cols: "12", sm: "12", md: "3", lg: "3", xl: "3" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-7" },
                    [
                      _c(
                        "v-col",
                        {
                          class: { "ta-c": _vm.smAndDown },
                          attrs: { cols: "12" },
                        },
                        [
                          _c("label", { staticClass: "filters-lbl" }, [
                            _vm._v("FILTERS"),
                          ]),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12",
                            sm: "12",
                            md: "12",
                            lg: "12",
                            xl: "10",
                          },
                        },
                        [
                          _c("smart-text-field", {
                            attrs: { placeholder: "Search Key" },
                            on: {
                              input: _vm.updateFilter,
                              "enter-pressed": function ($event) {
                                return _vm.search(null)
                              },
                            },
                            model: {
                              value: _vm.extendedOptions.searchKey,
                              callback: function ($$v) {
                                _vm.$set(_vm.extendedOptions, "searchKey", $$v)
                              },
                              expression: "extendedOptions.searchKey",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mt-4",
                          attrs: {
                            cols: "12",
                            sm: "12",
                            md: "12",
                            lg: "12",
                            xl: "10",
                          },
                        },
                        [
                          _c("smart-combobox", {
                            attrs: {
                              placeholder: "Origin Zip",
                              "append-icon": "",
                              "item-text": "formatted",
                            },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search(null)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "prepend-inner",
                                  fn: function () {
                                    return [
                                      _c("img", {
                                        staticClass: "mr-2 ml-2",
                                        staticStyle: { "margin-top": "4px" },
                                        attrs: {
                                          width: "12",
                                          src: _vm.ic_pin_white,
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              4087864824
                            ),
                            model: {
                              value: _vm.extendedOptions.originZip,
                              callback: function ($$v) {
                                _vm.$set(_vm.extendedOptions, "originZip", $$v)
                              },
                              expression: "extendedOptions.originZip",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mt-4",
                          attrs: {
                            cols: "12",
                            sm: "12",
                            md: "12",
                            lg: "12",
                            xl: "10",
                          },
                        },
                        [
                          _c("smart-combobox", {
                            attrs: {
                              placeholder: "Destination Zip",
                              "append-icon": "",
                              "item-text": "formatted",
                            },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search(null)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "prepend-inner",
                                  fn: function () {
                                    return [
                                      _c("img", {
                                        staticClass: "mr-2 ml-2",
                                        staticStyle: { "margin-top": "4px" },
                                        attrs: {
                                          width: "12",
                                          src: _vm.ic_pin_blue,
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              4026994593
                            ),
                            model: {
                              value: _vm.extendedOptions.destinationZip,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.extendedOptions,
                                  "destinationZip",
                                  $$v
                                )
                              },
                              expression: "extendedOptions.destinationZip",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mt-4",
                          attrs: {
                            cols: "12",
                            sm: "12",
                            md: "12",
                            lg: "12",
                            xl: "10",
                          },
                        },
                        [
                          _c("smart-combobox", {
                            attrs: {
                              multiple: "",
                              clearable: "",
                              items: _vm.carriersDdl,
                              label: "Select Carrier",
                              "menu-props": {
                                closeOnClick: true,
                                closeOnContentClick: true,
                              },
                            },
                            on: {
                              change: _vm.carrierSelected,
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                _vm.search(null)
                                $event.target.blur()
                              },
                            },
                            model: {
                              value: _vm.selectedCarriers,
                              callback: function ($$v) {
                                _vm.selectedCarriers = $$v
                              },
                              expression: "selectedCarriers",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mt-4",
                          attrs: {
                            cols: "12",
                            xs: "10",
                            sm: "12",
                            md: "12",
                            lg: "12",
                            xl: "10",
                          },
                        },
                        [
                          _c("smart-calendar", {
                            ref: "datePickerField",
                            attrs: {
                              label: "Create Date",
                              "background-color": "white",
                            },
                            on: {
                              "enter-pressed": function ($event) {
                                return _vm.search(null)
                              },
                              input: _vm.createdDateChanged,
                            },
                            model: {
                              value: _vm.createdDate,
                              callback: function ($$v) {
                                _vm.createdDate = $$v
                              },
                              expression: "createdDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm.isUserAdminAndNotImpersonating
                        ? _c(
                            "v-col",
                            {
                              staticClass: "mt-4",
                              attrs: {
                                cols: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                xl: "10",
                              },
                            },
                            [
                              _c("smart-combobox", {
                                key: _vm.users.length,
                                attrs: {
                                  items: _vm.accountsDdl,
                                  label: "Select Account",
                                  clearable: "",
                                },
                                on: {
                                  change: _vm.populateUsers,
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.search(_vm.extendedOptions)
                                  },
                                },
                                model: {
                                  value: _vm.selectedAccount,
                                  callback: function ($$v) {
                                    _vm.selectedAccount = $$v
                                  },
                                  expression: "selectedAccount",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-col",
                        {
                          staticClass: "mt-4",
                          attrs: {
                            cols: "12",
                            sm: "12",
                            md: "12",
                            lg: "12",
                            xl: "10",
                          },
                        },
                        [
                          _c("smart-combobox", {
                            key: _vm.rerenderUsers,
                            attrs: {
                              items: _vm.usersDdl,
                              label: "Select User",
                              clearable: "",
                            },
                            on: {
                              change: _vm.userChanged,
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.search(_vm.extendedOptions)
                              },
                            },
                            model: {
                              value: _vm.selectedUsername,
                              callback: function ($$v) {
                                _vm.selectedUsername = $$v
                              },
                              expression: "selectedUsername",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            cols: "12",
                            sm: "12",
                            md: "12",
                            lg: "12",
                            xl: "10",
                          },
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "clear-filters-btn pl-4",
                              on: { click: _vm.clearFilters },
                            },
                            [_vm._v("Clear Filters")]
                          ),
                        ]
                      ),
                      _vm.isUserAdminAndNotImpersonating
                        ? _c(
                            "v-col",
                            {
                              attrs: {
                                cols: "12",
                                sm: "12",
                                md: "12",
                                lg: "12",
                                xl: "10",
                              },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "clear-filters-btn pl-4",
                                  on: { click: _vm.openVltlQuotesSearch },
                                },
                                [_vm._v("VLTL Quotes Search")]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-col",
            {
              class: { "px-4": _vm.smAndDown },
              attrs: { sm: "12", lg: "8", xl: "7", md: "8" },
            },
            [
              _c(
                "v-row",
                { staticClass: "mt-7" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "results-header",
                      class: {
                        "ml-2": _vm.xl || _vm.lg,
                        "ml-n2": _vm.md,
                        "ta-c": _vm.smAndDown,
                      },
                      attrs: {
                        xs: "12",
                        sm: "12",
                        md: "12",
                        lg: "12",
                        xl: "12",
                      },
                    },
                    [
                      _c("label", { staticClass: "search-result" }, [
                        _vm._v(_vm._s(_vm.quotes.length)),
                      ]),
                      _vm._v(" quote results "),
                      _c("p", { staticClass: "mt-3 quote-results-lbl" }, [
                        _vm._v(
                          " Prices displayed may change based on availability. Prices are not final until you complete your booking. "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mb-16", attrs: { justify: "end" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pr-0",
                      attrs: {
                        xs: "auto",
                        sm: "auto",
                        md: "auto",
                        lg: "auto",
                        xl: "auto",
                      },
                    },
                    [
                      _c("smart-btn", {
                        attrs: {
                          type: "primary",
                          label: "New Quote",
                          to: "/customer/quotes/new",
                          css: _vm.newQuoteBtnCss,
                          icon: _vm.ic_plus,
                          "icon-class": "mr-2",
                          "icon-position": "left",
                          "icon-width": "12",
                        },
                      }),
                      _c("smart-btn", {
                        staticClass: "fr",
                        class: {
                          "w-100-pct mt-4": _vm.smAndDown,
                          "mr-4 export-csv": _vm.mdAndUp,
                        },
                        attrs: {
                          icon: _vm.ic_download,
                          label: "Export CSV",
                          "icon-class": "mr-2",
                          "icon-position": "left",
                          "icon-width": "18",
                          bg: "white",
                          border: "navy-blue",
                          font: "navy-blue",
                        },
                        on: { click: _vm.csvExport },
                      }),
                      _c("smart-btn", {
                        staticClass: "fr",
                        class: {
                          "w-100-pct mt-4": _vm.smAndDown,
                          "mr-4": _vm.mdAndUp,
                        },
                        attrs: {
                          label:
                            (_vm.showFilters ? "Less" : "More") + " Filters",
                          icon: _vm.ic_filters,
                          "icon-class": "mr-2",
                          "icon-position": "left",
                          "icon-width": "12",
                          bg: "white",
                          border: "navy-blue",
                          font: "navy-blue",
                        },
                        on: { click: _vm.toggleFilters },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  !_vm.loading
                    ? _c(
                        "v-col",
                        {
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            lg12: "",
                            xl12: "",
                          },
                        },
                        _vm._l(_vm.page, function (quote) {
                          return _c(
                            "v-layout",
                            { key: quote.id, attrs: { row: "" } },
                            [
                              _c("quote-card", {
                                attrs: {
                                  quote: quote,
                                  parcelQuotesOnlyEnabled:
                                    _vm.parcelQuotesOnlyEnabledComputed,
                                },
                                on: {
                                  copied: function (id) {
                                    return _vm.copied(id)
                                  },
                                  showDetails: function (details) {
                                    return _vm.showDetails(details)
                                  },
                                  openEmailForm: function (template) {
                                    return _vm.openEmailForm(template)
                                  },
                                  book: _vm.book,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.showNoData
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            lg12: "",
                            xl12: "",
                          },
                        },
                        [_c("no-data")],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      Math.round(_vm.quotes.length / _vm.pageSize) > 1 && !_vm.loading
        ? _c(
            "v-row",
            { staticClass: "mb-8", attrs: { justify: "center" } },
            [
              _vm.showFilters
                ? _c("v-col", {
                    class: {
                      "ml-n6 pr-10": _vm.md || _vm.lg,
                      "px-5": _vm.smAndDown,
                    },
                    attrs: { cols: "12", sm: "12", md: "3", lg: "3", xl: "3" },
                  })
                : _vm._e(),
              _c(
                "v-col",
                [
                  _c("v-pagination", {
                    attrs: {
                      length: Math.round(_vm.quotes.length / _vm.pageSize),
                    },
                    on: { input: _vm.pageChange },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function (ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "green", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackbar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.snackbarText) + " ")]
      ),
      _c("br"),
      _c(
        "div",
        {
          staticClass: "navigation-details",
          class: {
            active: _vm.displayDetails,
            "w-100-pct": _vm.smAndDown,
          },
        },
        [
          _c("quote-overview", {
            attrs: { quote: _vm.selectedQuote },
            on: {
              hide: function ($event) {
                _vm.displayDetails = false
              },
              copied: _vm.copied,
            },
          }),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v("Loading quotes..."),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("email-quote", {
        attrs: {
          display: _vm.showEmailQuotePopup,
          emailTemplate: _vm.emailTemplate,
          quote: _vm.emailingQuote,
        },
        on: {
          hide: function ($event) {
            _vm.showEmailQuotePopup = false
          },
          emailSent: _vm.emailSent,
        },
      }),
      _c(
        "v-overlay",
        { attrs: { value: _vm.booking, opacity: "0.75", color: "#fff" } },
        [
          _c(
            "v-row",
            [
              _c("v-col", { staticClass: "ta-c" }, [
                _c("img", {
                  staticClass: "rotating",
                  attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                }),
                _c("p", { staticClass: "overlay-txt mt-7" }, [
                  _vm._v("Hold Tight!"),
                ]),
                _c("p", { staticClass: "overlay-txt mt-n4" }, [
                  _vm._v("Preparing a shipment for you!"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }